import find from 'lodash/find';
import backToListView from 'src/actions/shared/backToListView';
import createCollectionResource from 'src/actions/shared/createResource';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { DomainError as StandardDomainError } from '@ad-scripts/application/lib/error';
import { Matches } from 'class-validator';
import { IsPropertyUniqueInStoreSlice } from 'src/actions/validators/IsPropertyUniqueInStoreSlice';
import { toastError, toastSuccess } from 'src/actions/toast';

export class Team {
  id: string;
  agentIds?: string[];
  description?: string;
  createdAt?: string;
  createdBy?: string;
  @IsPropertyUniqueInStoreSlice('teams', { message: 'This team name is already in use. Try another.' })
  @Matches(/\S/, { message: 'Enter a team name, special characters are allowed.' })
  name: string;
  _version: number;
}

const teamsResource = createCollectionResource<Team>({
  name: 'teams',
  endpoint: 'v1/orgs/:orgId/teams/:id',
  type: Team,
});

const add: sharedTypes.AppThunk =
  (_, team: Team) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(addStarted({}));
      await gateways.teams.addOrReplace({ id: team.id }, { ...team, _version: 1 });
      dispatch(addSuccess({}));

      backToListView();

      dispatch(toastSuccess(`Created "${team.name}" team`));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(addError(err.errors));
      } else {
        dispatch(addRequestError(err));
      }
      const toastMessage = 'There was an error while adding';
      dispatch(toastError(toastMessage));
    }
  };

const update: sharedTypes.AppThunk =
  (params: { id?: string }, team: Team) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(updateStarted({}));
      await gateways.teams.addOrReplace(params, { ...team, _version: team._version + 1 });
      dispatch(updateSuccess({}));

      backToListView();

      dispatch(toastSuccess(`Updated "${team.name}" team`));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(updateError(err.errors));
      } else {
        dispatch(updateRequestError(err));
      }
      const toastMessage = 'There was an error while updating';
      dispatch(toastError(toastMessage));
    }
  };

const deleteTeam: sharedTypes.AppThunk =
  ({ id }: { id: string }) =>
  async (dispatch, getState) => {
    const { values: teams } = getState().teams;
    const deletedTeam = find<Team>(teams, team => team.id === id);
    dispatch(teamsResource.effects.remove({ id }, { customToastMsg: `Deleted "${deletedTeam!.name}" team` }));
  };

const {
  addStarted,
  addSuccess,
  addError,
  addRequestError,
  updateStarted,
  updateSuccess,
  updateError,
  updateRequestError,
} = teamsResource.actions;

teamsResource.effects.add = add;
teamsResource.effects.update = update;
teamsResource.effects.deleteTeam = deleteTeam;

export default teamsResource;
